import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"

import Spinner from "components/Spinner"

import styles from "./LoadingOverlay.module.scss"

const shouldUseDialogElement = typeof HTMLDialogElement === "function"

const LoadingOverlay = (props, ref) => {
  const [tokens, setTokens] = useState([])
  const dialogRef = useRef()

  const Element = shouldUseDialogElement ? "dialog" : "div"

  useImperativeHandle(ref, () => ({
    open: () => {
      const token = Symbol()
      setTokens((state) => (token ? state.concat(token) : state))
      // return the finish callback for remove token
      return () => setTokens((state) => state.filter((item) => item !== token))
    },
    close: () => setTokens([]),
  }))

  useEffect(() => {
    if (shouldUseDialogElement) {
      if (!dialogRef.current.open && tokens.length) {
        dialogRef.current.showModal()
      }
      if (!tokens.length) dialogRef.current.close()
    }
  }, [dialogRef, tokens])

  return (
    <Element ref={dialogRef} className={styles.overlay} style={tokens.length ? {} : { display: "none" }}>
      <Spinner className={styles.spinner} />
    </Element>
  )
}

export default forwardRef(LoadingOverlay)
